import {
  ArticleEntity,
  TagEntity,
  CompanyEntity,
} from "@citychallenge/api-public";
import { Types } from "@citychallenge/common";
import { computed } from "mobx";
import { LocalizedMoment } from "../i18n";
import { MarkdownParser } from "../markdown";

export class ArticleModel implements ArticleEntity {
  public id!: string;
  public name!: string;
  public video?: string;
  public image?: string;

  public created?: string;
  public updated?: string;
  public published?: string;
  public body!: Types["MarkdownText"];
  public company!: CompanyEntity;
  public isPublished!: boolean;

  public tags?: TagEntity[];

  public tagIds: string[];

  constructor(data: ArticleEntity) {
    Object.assign(this, data);

    this.tagIds = data.tags ? data.tags.map((t) => t.id || "") : [];
  }

  public runningInHotlink?: boolean;

  @computed
  public get publication() {
    return new LocalizedMoment(this.published || this.created || new Date());
  }

  @computed
  public get preview() {
    return MarkdownParser.parsePreview(this.body.text);
  }

  public contains(regex: RegExp) {
    const {
      name,
      body: { text = "" },
    } = this;

    return regex.test(name) || regex.test(text);
  }
}
